import { findAssetForSlot } from '@/helpers/uploadFileHelper';

function toFeatureList(featureValues) {
  return Array.isArray(featureValues) ? featureValues : (featureValues ? [featureValues] : []);
}

export function normalizeAssetOptions(options) {
  if (!options) return [];
  if (Array.isArray(options)) {
    return options
      .filter((opt) => opt && opt.key)
      .map((opt) => ({
        ...opt,
        name: opt.name || opt.title
      }));
  }
  return Object.keys(options).map((id) => {
    const opt = options[id] || {};
    return {
      id,
      ...opt,
      key: opt.key || id,
      name: opt.name || opt.title || id
    };
  }).filter((opt) => opt.key);
}

const featuresList = [
  {
    name: 'Burndown',
    value: 'burndown'
  },
  {
    name: 'Countdown',
    value: 'countdown'
  },
  {
    name: 'Daily Promo',
    value: 'dailypromo'
  },
  {
    name: 'Handraiser',
    value: 'handraiser'
  },
  {
    name: 'Hotspot',
    value: 'hotspot'
  },
  {
    name: 'Product Feed',
    value: 'product_feed'
  },
  {
    name: 'Time Reactive',
    value: 'time_reactive'
  },
  {
    name: 'Weather Reactive',
    value: 'weather_reactive'
  },
  {
    name: 'Video',
    value: 'video'
  },
  {
    name: 'Showtimes Feed',
    value: 'showtimes_feed'
  },
  {
    name: 'Sticky Bottom',
    value: 'sticky_bottom'
  },
  {
    name: 'Sticky Top',
    value: 'sticky_top'
  },
  {
    name: 'Sticky Scroll',
    value: 'sticky_scroll'
  },
  {
    name: 'Skin',
    value: 'skin'
  },
  {
    name: 'Interruptor',
    value: 'interruptor'
  },
  {
    name: 'Interstitial',
    value: 'interstitial'
  },
  {
    name: 'Interscroller',
    value: 'interscroller'
  }
];

const featuresProperties = {
  'sticky_bottom': {
    assets: [
      {
        name: 'Wide footer image',
        asset_name: "bottom_bg",
        filename: 'bottom_bg.png',
        type: 'image',
        required: false
      },
      {
        name: 'Close button image',
        asset_name: "close_btn",
        filename: 'close_btn.png',
        type: 'image',
        required: false
      }
    ],
    options: [
      {
        name: 'Close button shown',
        tooltip: 'Whether the close button is shown',
        key: 'closeButtonShown',
        type: 'toggle',
        default: true
      },
      {
        name: 'Alignment of the Sticky Bottom',
        tooltip: 'The alignment of the sticky bottom',
        key: 'alignment',
        type: 'dropdown',
        values: [
          {
            name: 'Left',
            value: 'left'
          },
          {
            name: 'Center',
            value: 'center'
          },
          {
            name: 'Right',
            value: 'right'
          }
        ],
        default: 'center'
      }
    ]
  },
  'sticky_top': {
    assets: [
      {
        name: 'Close button image',
        asset_name: "close_btn",
        filename: 'close_btn.png',
        type: 'image',
        required: false
      }
    ]
  },
  'sticky_scroll': {
    assets: [
      {
        name: 'Close button image',
        asset_name: "close_btn",
        filename: 'close_btn.png',
        type: 'image',
        required: false
      },
      {
        name: 'Background image',
        description: 'The lower layer of the sticky scroll if no gradient is used',
        asset_name: "lower_layer",
        filename: 'lower_layer.png',
        type: 'image',
        options: {
          "allowed_tiled_background": {
            name: 'Tiled background',
            default: false,
            key: 'tiled_bg',
            type: 'toggle',
            tooltip: 'Whether the background image is tiled'
          }
        },
        required: false
      }
    ],
    options: [
      {
        name: 'Background gradient',
        tooltip: 'The background gradient of the sticky scroll',
        key: 'backgroundGradient',
        type: 'gradient-picker',
        value: 'linear-gradient(to right,rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.6))'
      },
      {
        name: 'Background opacity',
        tooltip: 'The opacity of the background of the sticky scroll',
        key: 'backgroundOpacity',
        type: 'slider',
        min: 0,
        max: 100,
        step: 1,
        default: 100,
        suffix: '%'
      },
      {
        name: 'Sticky scroll height',
        tooltip: 'The height of the sticky scroll in percentage of the screen height',
        key: 'stickyScrollHeight',
        type: 'slider',
        min: 0,
        max: 500,
        step: 1,
        default: 300,
        suffix: '%'
      }
    ],
    defaultCreativeSizes: [
      {
        name: 'Desktop Creative',
        value: '1200x800'
      },
      {
        name: 'Mobile Creative',
        value: '320x500'
      },
      {
        name: 'Tablet Portrait Creative',
        value: '768x700'
      },
      {
        name: 'Tablet Landscape Creative',
        value: '1024x500'
      }
    ]
  },
  'interruptor': {
    assets: [
      {
        name: 'Close button image',
        asset_name: "close_btn",
        filename: 'close_btn.png',
        type: 'image',
        required: false
      },
      {
        name: 'Background image',
        description: 'The background image of the Interruptor',
        asset_name: "lower_layer",
        filename: 'lower_layer.png',
        type: 'image',
        options: {
          "allowed_tiled_background": {
            name: 'Tiled background',
            default: false,
            key: 'tiled_bg',
            type: 'toggle',
            tooltip: 'Whether the background image is tiled'
          }
        },
        required: false
      }
    ],
    options: [
      {
        name: 'Background gradient',
        tooltip: 'The background gradient of the interruptor',
        key: 'backgroundGradient',
        type: 'gradient-picker',
        value: 'linear-gradient(to right,rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.6))'
      },
      {
        name: 'Background opacity',
        tooltip: 'The opacity of the background of the interruptor',
        key: 'backgroundOpacity',
        type: 'slider',
        min: 0,
        max: 100,
        step: 1,
        default: 100,
        suffix: '%'
      }
    ],
    defaultCreativeSizes: [
      {
        name: 'Desktop Creative',
        value: '1200x800'
      },
      {
        name: 'Mobile Creative',
        value: '320x500'
      },
      {
        name: 'Tablet Portrait Creative',
        value: '768x700'
      },
      {
        name: 'Tablet Landscape Creative',
        value: '1024x500'
      }
    ]
  },
  'skin': {
    assets: [],
    options: [],
    defaultCreativeSizes: [
      {
        name: 'Top Skin Creative',
        value: '1200x300'
      },
      {
        name: 'Left Skin Creative',
        value: '180x500'
      },
      {
        name: 'Right Skin Creative',
        value: '180x500'
      }
    ]
  }
}


class FeaturesService {
  getAll() {
    const features = featuresList.map((feature) => {
      return {
        ...feature,
        properties: featuresProperties[feature.value]
      }
    });
    return features;
  }
  getAllLayoutOptions() {
    const features = featuresList.map((feature) => {
      return {
        ...feature,
        properties: featuresProperties[feature.value]
      }
    });
    return features;
  }
  getPropertiesForFeature(featureValue) {
    return featuresProperties[featureValue] || null;
  }
  normalizeAssetOptions(options) {
    return normalizeAssetOptions(options);
  }
  getAssetOptionKeys(featureValues) {
    const keys = [];
    const seen = new Set();
    toFeatureList(featureValues).forEach((featureValue) => {
      const props = featuresProperties[featureValue];
      if (!props?.assets) return;
      props.assets.forEach((asset) => {
        normalizeAssetOptions(asset.options).forEach((opt) => {
          if (!opt.key || seen.has(opt.key)) return;
          seen.add(opt.key);
          keys.push(opt.key);
        });
      });
    });
    return keys;
  }
  getFeatureAssetsForCreative(featureValues, creativeAssets) {
    const matched = [];
    const seen = new Set();
    toFeatureList(featureValues).forEach((featureValue) => {
      const props = featuresProperties[featureValue];
      if (!props?.assets) return;
      props.assets.forEach((slot) => {
        const saved = findAssetForSlot(creativeAssets, slot);
        if (!saved) return;
        const id = saved.id || saved.filename;
        if (seen.has(id)) return;
        seen.add(id);
        matched.push(saved);
      });
    });
    return matched;
  }
}

export default new FeaturesService();
